import React, { PureComponent } from 'react';
import BowSection from '../BowSection';

export default class BowSelectionProcess extends PureComponent {
	contentOptions = () => ({
		title: 'Congrats to Our Winners!',
		body: (
			<p>
				Search this year’s winners including the best wedding venues, wedding
				photographers, wedding planners, wedding DJs and more.
			</p>
		),
	});

	render() {
		const { title, body } = this.contentOptions();
		return <BowSection title={title} titleType="h2" body={body} />;
	}
}
